import { useState } from 'react';
import axios from 'axios';
import axiosInstance from '../../../../../axios/axiosInstance';
export const useUploadImage = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const uploadImage = async (req: FormData) => {
    try {
      setLoading(true);
      const res = await axiosInstance({
        url: 'media/ckeditor/upload',
        method: 'post',
        data: req,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setLoading(false);
      return res;
    } catch (error) {
      setLoading(false);
    }
  };
  return { uploadImage, loading };
};
